import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEmployeeAuth } from "../auth/EmployeeAuthContext";

const EmployeeLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useEmployeeAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      if (email === "kanishka@driveeasy.co.in") {
        navigate("/employee/hr-dashboard");
      } else {
        navigate("/employee/dashboard");
      }
    } catch (err) {
      setError("Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-neutral-900 font-poppins transition-colors">
      <div className="bg-white dark:bg-neutral-800 shadow-2xl rounded-2xl p-10 w-96 border border-gray-200 dark:border-neutral-700">
        <h2 className="text-3xl font-bold text-center text-driveeasy-blue2 mb-8">
          Employee Login
        </h2>

        {error && (
          <p className="text-red-400 dark:text-red-300 text-sm text-center mb-4 bg-red-50 dark:bg-red-900/30 py-2 rounded-lg">
            {error}
          </p>
        )}

        <form onSubmit={handleLogin} className="flex flex-col gap-5">
          <input
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border border-gray-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 rounded-xl px-5 py-3 text-gray-800 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-driveeasy-blue/30 transition-all"
            required
          />
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border border-gray-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 rounded-xl px-5 py-3 text-gray-800 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-driveeasy-blue/30 transition-all"
            required
          />
          <button
            type="submit"
            className="bg-driveeasy-blue hover:bg-driveeasy-blue2 text-white font-semibold rounded-xl py-4 shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200"
          >
            Login Securely
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Powered by <span className="font-bold text-driveeasy-blue2">DriveEasy HR</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmployeeLogin;